// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    redirect: string;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-Login',
    templateUrl: './Login.html',
    styleUrls: ['./Login.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class Login extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.Login';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    input_redirect = input(undefined, { alias: 'redirect' });
    var_redirect = proxySignal<string>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get redirect() { return component.var_redirect() },
                set redirect(value: string) { component.var_redirect.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            redirect: this.screen.redirect
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_redirect = this.dialogData?.data?.redirect ?? this.input_redirect() ?? (undefined)
            if (new_redirect !== undefined) this.screen.redirect = new_redirect

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
